import { render, staticRenderFns } from "./training-type.vue?vue&type=template&id=239e9ceb&"
import script from "./training-type.vue?vue&type=script&lang=js&"
export * from "./training-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports